export default __webpack_public_path__ + "static/media/rating_web-xs@1x.a703a78f.jpg";